import { PatientLayout } from 'containers/PatientLayout';
import { useAuth } from 'context/AuthContext';
import { SupportCard } from './SupportCard';
import { PageHelmet } from '../../components/common/PageHelmet';
import { useCommonTranslation } from '../../hooks/i18n/useCommonTranslation';

export const UnAuthAndPatientSupportFormPage = () => {
  const { sangixUser } = useAuth();
  const { t } = useCommonTranslation();

  return (
    <PatientLayout graphics={Boolean(sangixUser) ? 'patient' : 'unauth'}>
      <PageHelmet title={t('contact-us')} />
      <SupportCard />
    </PatientLayout>
  );
};
